import styled, { css } from 'styled-components';
import zIndexes from '../../../styles/zIndexes';
import { Theme } from '../../../types/utility';
import { Icon } from '../../atoms';
import { ISelectProps } from '../../../types/formTypes';

const stateStyles = css`
  &:focus,
  &.focus {
    outline: ${({ theme }) => `3px solid ${(theme as Theme).colors.lapisLazuli}`};
  }

  &.disabled {
    background-color: ${({ theme }) => (theme as Theme).colors.lightgrey};
    color: ${({ theme }) => (theme as Theme).colors.lightgrey};
    pointer-events: none;
    cursor: none;
  }
`;

const borderStyles = css`
  border-radius: 0;
  outline: 1px solid ${({ theme }) => (theme as Theme).colors.darkgrey};
`;

const noMarginAndPaddingStyles = css`
  margin: 0;
  padding: 0;
`;

const listItemStyles = css`
  list-style: none;
  user-select: none;
`;

export const ArrowIcon = styled(Icon).attrs(({ theme }) => ({
  iconName: 'DropdownArrow',
  color: (theme as Theme).colors.black,
  title: 'Select Arrow',
}))`
  pointer-events: none;

  max-width: 24px;
  max-height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Wrapper = styled.div`
  ${noMarginAndPaddingStyles}
  height: initial;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SelectWrapper = styled.div`
  ${noMarginAndPaddingStyles}
  height: inherit;
`;

export const Options = styled.div`
  z-index: 1;

  ${noMarginAndPaddingStyles}
  ${borderStyles}
`;

export const Option = styled.li<{ hover: boolean }>`
  ${noMarginAndPaddingStyles}
  ${listItemStyles}

  ${({ theme, hover }) => {
    const { lightgrey, midgrey } = (theme as Theme).colors;
    if (hover) return `background-color: ${midgrey}`;
    return `
        background-color: ${lightgrey};
        &:hover { background-color: ${midgrey} }
    `;
  }}
`;

const selectStyles = (width: string, height: string) => css`
  position: relative;
  z-index: ${zIndexes[3]};

  width: ${width};
  height: ${height};

  * {
    width: ${width};
  }

  ${Options} {
    position: absolute;
    top: ${height};
  }
  ${Option} {
    height: ${height};
  }
  p {
    height: ${height};
    padding-inline: 20px;

    display: flex;
    align-items: center;
  }
`;
export const SelectList = styled.ul<Pick<Required<ISelectProps>, 'width' | 'height'>>`
  ${({ width, height }) =>
    selectStyles(width === 'default' ? `354px` : `${width}px`, height === 'default' ? `48px` : `${height}px`)}

  ${stateStyles}
  ${noMarginAndPaddingStyles}
  ${listItemStyles}
  ${borderStyles}

  & ${ArrowIcon} {
    position: absolute;

    top: 13px;
    right: 16px;
  }
`;
